/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { all, fork } from "redux-saga/effects";
import {watchPollGetRedlineData} from "./ducks/CoverageRequirements/sagas";

const rootSaga = function* () {
  yield all([
    fork(watchPollGetRedlineData)
  ]);
};

export default rootSaga;